
<template>
    <div class="story" :class="{ preview: preview }" id="viewport-for-capture" :style="{ width: resolution + 'px' }">
        <Phone v-if="preview && formData" :showNotch="false">
            <StoryMaker
                :formData="formData"
                :idStorySelected="idStorySelected"
                :pageSelected="page"
                :previewEnabled="true"
                :files="files"
            />
        </Phone>

         <StoryMaker
            v-else-if="formData && !preview"
            :formData="formData"
            :idStorySelected="idStorySelected"
            :pageSelected="page"
            :previewEnabled="true"
            :files="files"
        />
    </div>
</template>

<script>
    import StoryMaker from '../dash/postCreator/components/storyTab/StoryMaker.vue';
    import Phone from "@/components/dash/postCreator/components/Phone.vue" 
    import { parseYYYYMMDD } from '@/utils/Date.js'
    export default {
        components: {
            StoryMaker,
            Phone
        },
        props: {
            idStorySelected: String,
            preview: Boolean,
        },
        data() {
            return {
                formData : null,
                page: null,
                files: {},
                resolution: 1080
            }
        },
    
        created () {
            if (localStorage.storificationPreviewData) {
             
                const storificationPreviewData = JSON.parse(localStorage.storificationPreviewData)

                this.files = storificationPreviewData.files
                this.formData = {
                    storification: storificationPreviewData.storification
                }
                this.page = storificationPreviewData.page
                this.resolution= storificationPreviewData.resolution ? storificationPreviewData.resolution : 1080
                if (this.verifIdStorySelected() && !this.preview) this.getDataStorification();
             
            }
           
           

            //calcule X, Y HEIGHT, WIDTH ROTATION
        },
        mounted () {
           
        },
        methods: {
            verifIdStorySelected() {
                if (!this.idStorySelected || !this.formData.storification[this.idStorySelected]) {
                    const firstStoryId = Object.keys(this.formData.storification)[0];
                    if (firstStoryId) {
                        this.$router.push({ path: `/preview/story/${firstStoryId}`, query: this.$route.query });
                    }
                }else{
                    return true
                }
                return false
            },
            getDataStorification() {
                this.$nextTick(async ()=> {
                    let data = {
                        text: [],
                        link:null,
                        poll:null,
                        question:null,
                        slider:null,
                        location:null,
                        product:null,
                        mentions:[],
                        facebookMentions:[],
                        hashtags:[],
                        gifs:[],
                        images:[],
                        music:null,
                        post: null
                    }
                    let sticker, element, media, scale;
                    let idStory = this.idStorySelected

                    const backgroundConfig = this.formData.storification[idStory].background
                    data.backgroundColor = backgroundConfig.color

                    if (backgroundConfig.file && backgroundConfig.file.id) {
                        data.backgroundFile = {
                            url: this.files[backgroundConfig.file.id].url,
                            x: this.resolution / 100 * parseFloat(backgroundConfig.position.x),
                            y: this.resolution*16/9 / 100 * parseFloat(backgroundConfig.position.y),
                            angle: backgroundConfig.transform.rotate
                        }

                        if (backgroundConfig.size == 'containX') {
                            data.backgroundFile.width= this.resolution * backgroundConfig.transform.scale
                            data.backgroundFile.height= data.backgroundFile.width / this.files[backgroundConfig.file.id].info.aspectRatio
                        }else if (backgroundConfig.size == 'containY') {
                            data.backgroundFile.height= this.resolution*16/9 * backgroundConfig.transform.scale
                            data.backgroundFile.width= data.backgroundFile.width * this.files[backgroundConfig.file.id].info.aspectRatio
                        }
                    }

                    const setInfoStickerCalculate = (stickerObject) => {
                        element = document.querySelector(`.id-${stickerObject.id}`)
                        scale = stickerObject.transform && stickerObject.transform.hasOwnProperty('scale') && typeof stickerObject.transform.scale == "number" ? stickerObject.transform.scale : 1

                        if (element) {
                            stickerObject.w = element.offsetWidth * scale
                            stickerObject.h = element.offsetHeight * scale
                            stickerObject.x = element.style.left.endsWith('%') ? this.resolution / 100 * parseFloat(element.style.left.slice(0,-1)) : 0
                            stickerObject.y = element.style.top.endsWith('%') ? this.resolution*16/9 / 100 * parseFloat(element.style.top.slice(0,-1)) : 0
                            stickerObject.angle = stickerObject.transform.rotate
                        }   
                        console.log('setInfoStickerCalculate', stickerObject.type, element.offsetHeight, element.offsetWidth, scale)
                    }
                   
                    for (const stickerId of Object.keys(this.formData.storification[idStory].stickers)) {
                        sticker = this.formData.storification[idStory].stickers[stickerId]
                        element = document.querySelector(`.id-${stickerId}`)

                        switch (sticker.type) {
                            case 'text': 
                                setInfoStickerCalculate(sticker)
                                data.text.push({
                                    w: sticker.w,
                                    h: sticker.h, 
                                    x: sticker.x,
                                    y: sticker.y,
                                    content: sticker.data.text,
                                    color: sticker.data.color,
                                    size: sticker.data.fontSize,
                                    background: {"secondary": 1, "primary": 2,"none" : 0}[sticker.data.background],
                                    font: ["modern-font", "classic-font","signature-font", "editor-font", "poster-font", "bubble-font", "deco-font", "squeeze-font", "typewriter-font", "strong-font", "meme-font", "elegant-font", "directional-font", "literature-font"][sticker.data.font],
                                    fontName: sticker.data.font
                                })

                                if (sticker.data.mentions) {
                                    const canvasRect = document.querySelector('#viewport-for-capture').getBoundingClientRect()
                                    Object.entries(sticker.data.mentions).forEach(([mentionId, m]) => {
                                        if (!m.mention || !m.mention.facebook) return
                                        const span = element.querySelector(`.tag-mention[idmention="${mentionId}"]`)
                                        if (!span) return
                                        const rect = span.getBoundingClientRect()
                                        data.facebookMentions.push({
                                            tagId: m.mention.facebook.id,
                                            bounds: {
                                                x: (rect.left - canvasRect.left) / canvasRect.width,
                                                y: (rect.top - canvasRect.top) / canvasRect.height,
                                                width: rect.width / canvasRect.width,
                                                height: rect.height / canvasRect.height,
                                                rotation: sticker.angle,
                                            }
                                        })
                                    })
                                }
                                break;
                            case 'link':
                                setInfoStickerCalculate(sticker)
                                data.link = {}
                                data.link.w= sticker.w
                                data.link.h= sticker.h 
                                data.link.x= sticker.x
                                data.link.y= sticker.y
                                data.link.angle= sticker.angle
                                data.link.styleVariant= sticker.data.styleVariant
                                data.link.custom_cta= sticker.data.text
                                data.link.url= sticker.data.link
                                break;

                            case 'survey':
                                setInfoStickerCalculate(sticker)
                                data.poll = {}
                                data.poll.w= sticker.w
                                data.poll.h= sticker.h 
                                data.poll.x= sticker.x
                                data.poll.y= sticker.y
                                data.poll.angle= sticker.angle
                                data.poll.question= sticker.data.question
                                data.poll.responses= sticker.data.responses
                                data.poll.color= sticker.data.color
                                break;
                            case 'question':
                                setInfoStickerCalculate(sticker)
                                data.question = {}
                                data.question.w= sticker.w
                                data.question.h= sticker.h 
                                data.question.x= sticker.x
                                data.question.y= sticker.y
                                data.question.angle= sticker.angle
                                data.question.question= sticker.data.question
                                data.question.color= sticker.data.color
                                break;

                            case 'slider':
                                setInfoStickerCalculate(sticker)
                                data.slider = {}
                                data.slider.w= sticker.w
                                data.slider.h= sticker.h 
                                data.slider.x= sticker.x
                                data.slider.y= sticker.y
                                data.slider.angle= sticker.angle
                                data.slider.question= sticker.data.question
                                data.slider.emoji= sticker.data.emoji
                                data.slider.backgroundColor= sticker.data.color
                                data.slider.emoji= sticker.data.emoji
                                break;
                                // data.slider.textColor= //gatien

                            case 'localisation':
                                setInfoStickerCalculate(sticker)
                                data.location = {}
                                data.location.w= sticker.w
                                data.location.h= sticker.h 
                                data.location.x= sticker.x
                                data.location.y= sticker.y
                                data.location.angle= sticker.angle
                                data.location.locationId= sticker.data.place.id
                                data.location.locationName= sticker.data.place.name
                                data.location.styleVariant= sticker.data.styleVariant
                                break;
                            case 'product':
                                setInfoStickerCalculate(sticker)
                                data.product = {}
                                data.product.w= sticker.w
                                data.product.h= sticker.h 
                                data.product.x= sticker.x
                                data.product.y= sticker.y
                                data.product.angle= sticker.angle
                                data.product.products= sticker.data.products
                                data.product.font= ["modern-font", "classic-font","signature-font", "editor-font", "poster-font", "bubble-font", "deco-font", "squeeze-font", "typewriter-font", "strong-font", "meme-font", "elegant-font", "directional-font", "literature-font"][sticker.data.font],
                                data.product.fontName= sticker.data.font
                                data.product.styleVariant= sticker.data.styleVariant
                                break;
                            case 'mention':
                                setInfoStickerCalculate(sticker)
                                data.mentions.push({
                                    w: sticker.w,
                                    h: sticker.h, 
                                    x: sticker.x,
                                    y: sticker.y,
                                    angle: sticker.angle,
                                    hide: false,
                                    username: sticker.data.mention.id,
                                    pk: sticker.data.mention.pk,
                                    styleVariant: sticker.data.styleVariant
                                })

                                if (this.page && this.page.network === 'facebook' && sticker.data.mention && sticker.data.mention.id) {
                                    data.facebookMentions.push({
                                        tagId: sticker.data.mention.id,
                                        bounds: {
                                            x: (sticker.x - sticker.w / 2) / this.resolution,
                                            y: (sticker.y - sticker.h / 2) / (this.resolution * 16 / 9),
                                            width: sticker.w / this.resolution,
                                            height: sticker.h / (this.resolution * 16 / 9),
                                            rotation: sticker.angle,
                                        }
                                    })
                                }
                                break;
                            case 'hashtag':
                                setInfoStickerCalculate(sticker)
                                data.hashtags.push({
                                    w: sticker.w,
                                    h: sticker.h, 
                                    x: sticker.x,
                                    y: sticker.y,
                                    angle: sticker.angle,
                                    hide: false,
                                    tagName: sticker.data.hashtag,
                                    styleVariant: sticker.data.styleVariant
                                })
                                break;
                            case 'gif':
                            
                                media = element.querySelector('.sticker-gif img[data-check-load]')
                                await this.waitForImageToLoad(media)
                                setInfoStickerCalculate(sticker)
                                data.gifs.push({
                                    w: sticker.w,
                                    h: sticker.h, 
                                    x: sticker.x,
                                    y: sticker.y,
                                    angle: sticker.angle,
                                    gifId: sticker.data.gif.id,
                                    gif: sticker.data.gif,
                                })
                                break;
                            case 'image' :
                                media = element.querySelector('img[data-check-load]')
                                await this.waitForImageToLoad(media)
                                setInfoStickerCalculate(sticker)
                                if (sticker.data.idFile && this.files[sticker.data.idFile]) {
                                    data.images.push({
                                        w: sticker.w,
                                        h: sticker.h, 
                                        x: sticker.x,
                                        y: sticker.y,
                                        angle: sticker.angle,
                                        url: this.files[sticker.data.idFile].url,
                                    })
                                }
                            break;
                            case 'music':
                                data.music = {}
                                data.music.start= sticker.data.start
                                data.music.duration= sticker.data.rangeDuration
                                data.music.musicId= sticker.data.music.track ? sticker.data.music.track.id : sticker.data.music.original_sound.original_media_id;
                                data.music.music= sticker.data.music
                                break;
                            case 'post': 
                                if (
                                   (sticker.data.idFile && this.files[sticker.data.idFile]) || //v1 post sticker
                                   (sticker.data.url && sticker.data.type)   //v2 post sticker
                                ) {
                                    const type2 = sticker.data.type || this.files[sticker.data.idFile].info.type2

                                    if (type2 == 'image') {
                                        media = element.querySelector('img[data-check-load]')
                                        await this.waitForImageToLoad(media)
                                    }else if (type2 == 'video') {
                                        media = element.querySelector('video[data-check-load]')
                                        await this.waitForVideoToLoad(media)
                                    }
                                    setInfoStickerCalculate(sticker)
                                        
                                    data.post = {}
                                    data.post.w= sticker.w
                                    data.post.h= sticker.h 
                                    data.post.x= sticker.x
                                    data.post.y= sticker.y
                                    data.post.angle= sticker.angle
                                    data.post.styleVariant= sticker.data.styleVariant
                                    data.post.media_id= sticker.data.media_id || null
                                    data.post.owner_user_id= sticker.data.owner_user_id || null
                                    data.post.typePost= sticker.data.typePost
                                    data.post.fileType= sticker.data.fileType

                                    if (type2 == 'video') {
                                        const media = element.querySelector('.media-post')
                                        if (media) {
                                            data.post.media = {}
                                            const rect = media.getBoundingClientRect();
                                            data.post.media.w= rect.width
                                            data.post.media.h= rect.height
                                            data.post.media.x= rect.left + window.scrollX + (rect.width / 2)
                                            data.post.media.y= rect.top + window.scrollY + (rect.height / 2)
                                            data.post.media.angle= sticker.angle

                                            data.post.media.url= sticker.data.url || this.files[sticker.data.idFile].url

                                            data.post.media.borderRadius= {
                                                top: 0,
                                                bottom: 0
                                            }
                                            //border radius 
                                            const scale = sticker.transform && sticker.transform.hasOwnProperty('scale') && typeof sticker.transform.scale == "number" ? sticker.transform.scale : 1
                                            const borderRadius = 32/1080 * this.resolution * scale
                                            if (!element.querySelector('.sticker-post-header')) {
                                                data.post.media.borderRadius.top = borderRadius
                                            }

                                            if (!element.querySelector('.sticker-post-footer')) {
                                                data.post.media.borderRadius.bottom = borderRadius
                                            }

                                         
                                        }
                                    }
                                   
                    

                                }
                                break;

                            case 'countdown':
                                setInfoStickerCalculate(sticker)
                                data.countdown = {}
                                data.countdown.w= sticker.w
                                data.countdown.h= sticker.h 
                                data.countdown.x= sticker.x
                                data.countdown.y= sticker.y
                                data.countdown.angle= sticker.angle
                                data.countdown.text= sticker.data.name


                                // date/hours/minutes are a wall-clock time in the page's timezone (emulated by the Navigator Lambda)
                                let endTs = parseYYYYMMDD(sticker.data.date)

                                if (sticker.data.hours !== false && sticker.data.minutes !== false) {
                                    endTs.setHours(parseInt(sticker.data.hours))
                                    endTs.setMinutes(parseInt(sticker.data.minutes))
                                }
                                endTs = parseInt(endTs.getTime()/1000)
                                
                                data.countdown.endTs = endTs
                                data.countdown.backgroundColor= sticker.data.color.toLowerCase()
                                break;
                            default:
                                break;
                        }
                    };

                    try {
                        const jsonString = JSON.stringify(data, null, 2);
                        const blob = new Blob([jsonString], { type: "application/json" });
                        const blobUrl = URL.createObjectURL(blob);
                        const newWindow = window.open(blobUrl, '_blank');
                    } catch (error) {
                        console.error("Impossible d'ouvrir une nouvelle fenêtre.");
                    }
                       

                })
            },

            waitForImageToLoad(img) {
                return new Promise((resolve, reject) => {
                    if (img.complete && img.naturalHeight !== 0 && img.naturalWidth !== 0) {
                        setTimeout(() => {resolve()}, 0);
                    } else {
                        // Attends que l'image déclenche l'événement "load"                                      
                        img.onload = () => {
                            requestAnimationFrame(() => {
                                resolve();
                            });
                        };
                        img.onerror = () => reject(new Error("Échec du chargement de l'image"));
                    }
                });
            },

            waitForVideoToLoad(video) {
                return new Promise((resolve, reject) => {
                    if (video.readyState >= 3) { // readyState 3 (HAVE_FUTURE_DATA) signifie que la vidéo est prête à être lue
                        resolve();
                    } else {
                        video.onloadeddata = () => {
                            requestAnimationFrame(() => {
                                resolve();
                            });
                        }
                        video.onerror = () => reject(new Error("Échec du chargement de la vidéo"));
                    }
                });
            }
        },
        watch : {
            idStorySelected() {
                if (this.verifIdStorySelected()) this.getDataStorification();
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>